import { motion } from "framer-motion";
import { Check, Loader2 } from "lucide-react";

/**
 * Animated execution pipeline stepper.
 * stages: string[], current: index of running stage (stages < current are done), done: all complete
 */
export const ExecutionPipeline = ({ stages, current, done }) => (
  <div className="space-y-0" data-testid="execution-pipeline">
    {stages.map((stage, i) => {
      const isDone = done || i < current;
      const isRunning = !done && i === current;
      const isPending = !done && i > current;
      return (
        <div key={stage} className="flex items-stretch gap-3">
          <div className="flex flex-col items-center">
            <motion.div
              initial={false}
              animate={{ scale: isRunning ? 1.05 : 1 }}
              className={`flex h-5 w-5 items-center justify-center rounded-full border text-[9px] ${
                isDone
                  ? "border-[rgba(34,197,94,0.4)] bg-[rgba(34,197,94,0.15)] text-[#4ADE80]"
                  : isRunning
                  ? "border-[rgba(79,142,247,0.5)] bg-[rgba(79,142,247,0.15)] text-[#7FAEF9]"
                  : "border-[#2a2a2a] bg-[#161616] text-[#555]"
              }`}
            >
              {isDone ? <Check size={10} /> : isRunning ? <Loader2 size={10} className="animate-spin" /> : i + 1}
            </motion.div>
            {i < stages.length - 1 && (
              <div className={`w-px flex-1 ${isDone ? "bg-[rgba(34,197,94,0.3)]" : "bg-[#222]"}`} style={{ minHeight: 10 }} />
            )}
          </div>
          <div className={`pb-2.5 text-[12px] leading-5 ${isDone ? "text-[#e5e5e5]" : isRunning ? "text-[#7FAEF9]" : "text-[#555]"}`}>
            {stage}
            {isRunning && <span className="ml-1.5 text-[10px] text-[#4F8EF7]">running…</span>}
          </div>
        </div>
      );
    })}
  </div>
);
